import { Banner, Button, Stack, TextContainer, Text, Link, Icon } from "@shopify/polaris";
import { CircleAlertMajor } from '@shopify/polaris-icons'
import { useEffect } from "react";
import styles from './UsedProductsBanner.module.css';

const UsedProductsBanner = ({ setIsBannerChecked, setIsProductUsed, bannerValidError, setBannerValidError }) => {
    useEffect(() => {
        setIsBannerChecked(false);
        setBannerValidError(false);
    }, [setIsBannerChecked]);

    const handleButtonClick = () => {
        setIsBannerChecked(true);
        setIsProductUsed(false);
    };

    return (
        <div className={styles.bannerWrapper}>
            <div className={bannerValidError ? styles.shake : ''}>
                <Banner status="warning">
                    <Stack vertical>
                        <TextContainer>
                            <Text as="p" variant="bodyLg">
                                Each product can only be part of one action at a time. If you select products that are already included in another action, they will be removed from that action and added to this one instead. Please click OK to acknowledge. <Link url="https://help.stockhide.com/help/how-is-limiting-each-product-to-one-action-useful-for-customers?version=latest">Learn more</Link>
                            </Text>
                        </TextContainer>
                        <div className={styles.bannerContent}>
                            <Stack alignment="center" spacing="tight">
                                {bannerValidError && (
                                    <div className={styles.errorWrapper}>
                                        <Icon source={CircleAlertMajor} color="critical" />
                                        <p className={styles.errorText}>Required</p>
                                    </div>
                                )}
                                <Button onClick={handleButtonClick}>
                                    OK
                                </Button>
                            </Stack>
                        </div>
                    </Stack>
                </Banner>
            </div>
        </div >
    );
};

export default UsedProductsBanner;
